﻿import { countryLanguage } from "../models/countryLanguageModel.js";
import { getTranslations } from "../translations.js";

export class CountryPopup
{
    private getCountrySelection()
    {
        const countryLanguages: Array<countryLanguage> = [];

        let nl = document.querySelector<HTMLLinkElement>("head link[rel='alternate'][hreflang='nl-nl']")?.href;
        let benl = document.querySelector<HTMLLinkElement>("head link[rel='alternate'][hreflang='nl-be']")?.href;
        let befr = document.querySelector<HTMLLinkElement>("head link[rel='alternate'][hreflang='fr-be']")?.href;
        let fr = document.querySelector<HTMLLinkElement>("head link[rel='alternate'][hreflang='fr-fr']")?.href;

        if (!nl)
            nl = "https://www.smulderstextiel.nl";

        if (!benl)
            benl = "https://www.smulderstextiel.be";

        if (!befr)
            befr = "https://www.smulderstextiles.be";

        if (!fr)
            fr = "https://www.smulderstextiles.fr";

        if (nl)
            countryLanguages.push({ language: "nl", country: "nl", url: nl, title: "Smulderstextiel.nl", siteID: 1 });

        if (benl)
            countryLanguages.push({ language: "nl", country: "be", url: benl, title: "Smulderstextiel.be", siteID: 5 });

        if (befr)
            countryLanguages.push({ language: "fr", country: "be", url: befr, title: "Smulderstextiles.be", siteID: 72 });

        if (fr)
            countryLanguages.push({ language: "fr", country: "fr", url: fr, title: "Smulderstextiles.fr", siteID: 69 });

        return countryLanguages;
    }

    // Content for the country pop-ups
    public getCountryContent(includeTitle: Boolean = true)
    {
        const countryContentEl = document.createElement("div");
        if (includeTitle)
        {
            const countryContentTitleEl = document.createElement("span");
            countryContentTitleEl.className = "c-countrydropdown__title f-secondary-l";
            countryContentTitleEl.innerText = getTranslations().langPopupTitle;
            countryContentEl.appendChild(countryContentTitleEl);
        }

        const countryContentTextEl = document.createElement("p");
        countryContentTextEl.className = "c-countrydropdown__text f-primary-s";
        countryContentTextEl.innerText = getTranslations().langPopupText;
        countryContentEl.appendChild(countryContentTextEl);

        const countrySelectEl = document.createElement("div");
        const countrySelectTitleEl = document.createElement("span");
        countrySelectTitleEl.className = "c-countrydropdown__subtitle f-primary-s tl-bold";
        countrySelectTitleEl.innerText = getTranslations().txtChooseCountry;
        countrySelectEl.appendChild(countrySelectTitleEl);

        this.getCountrySelection().forEach((item: countryLanguage) =>
        {
            const countryItemEl = document.createElement("div");
            countryItemEl.className = "c-countrydropdown__item";

            let radioID = `countryselect-${item.country}-${item.language}`;

            while (document.getElementById(radioID))
                radioID += "-1";

            const countryRadiobutton = document.createElement("input");
            countryRadiobutton.className = "c-countrydropdown__input u-customradio__input";
            countryRadiobutton.type = "radio";
            countryRadiobutton.id = radioID;
            countryRadiobutton.name = "countryselect";

            if (Number(shopConfig().currentSiteID) === item.siteID)
            {
                countryRadiobutton.checked = true;
            }
            else if (item.url)
            {
                const hostName = new URL(item.url)?.origin;
                if (hostName === location.origin)
                    countryRadiobutton.checked = true;
            }

            countryRadiobutton.onchange = () =>
            {
                location.href = item.url;
            };

            const countryLabelEl = document.createElement("label");
            countryLabelEl.className = "u-customradio__label c-countrydropdown__label";
            countryLabelEl.setAttribute("for", radioID);

            const countryTextSpanEl = document.createElement("span");
            countryTextSpanEl.className = `c-countrydropdown-radio__text`;
            countryTextSpanEl.innerText = item.title;
            countryLabelEl.prepend(countryTextSpanEl);

            const countrySelectSpanEl = document.createElement("span");
            countrySelectSpanEl.className = `u-customradio__span`;
            countryLabelEl.prepend(countrySelectSpanEl);

            const countrySpanEl = document.createElement("span");
            countrySpanEl.className = `c-mobilemenu__country c-mobilemenu-country__${item.country}`;
            countryLabelEl.appendChild(countrySpanEl);

            if (item.language !== item.country)
            {
                const countryLanguageSpanEl = document.createElement("span");
                countryLanguageSpanEl.className = `c-mobilemenu__country c-mobilemenu-country__${item.language}`;
                countryLabelEl.appendChild(countryLanguageSpanEl);
            }

            countryItemEl.appendChild(countryRadiobutton);
            countryItemEl.appendChild(countryLabelEl);
            countrySelectEl.appendChild(countryItemEl);
        });

        countryContentEl.appendChild(countrySelectEl);

        return countryContentEl;
    }
};
